import { Chip } from '@frontierag/frontier-ui-library';
import { styles } from './styles';
import type { IProductRefChip } from './types';

export default function ProductRefChip({ productRef }: IProductRefChip) {
  return <Chip size="small" label={productRef} sx={styles.chip} color="primary" />;
}
